import { Component, Input } from "@angular/core";
import { ReviewDataCardComponent } from "../review-card/review-data-card.component";
import { HttpCommonService, AuthService, LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { ReviewService } from "../review.service";

@Component({
  selector: "sepidz-kpi-review",
  templateUrl: "./kpi-review.component.html",
  styleUrls: ["./kpi-review.component.scss"],
})
export class KpiReviewComponent extends ReviewDataCardComponent {
  public data = {};
  @Input()
  bundles: ReviewKpiItemBundle[] = [];
  constructor(service: ReviewService, fetchService: HttpCommonService, protected lookupservice: LookupService, protected authService: AuthService) {
    super(service, fetchService, lookupservice, authService);
  }

  protected retrieved(data: any): void {
    this.data = data;
  }
}

export interface ReviewKpiItemBundle {
  item1: ReviewKpiItem;
  item2?: ReviewKpiItem;
  class: string;
}

export interface ReviewKpiItem {
  name: string;
  displayName: string;
}
